<div class="admin-notifications-page">
  <p-toast></p-toast>
  <ng-template #ruleProcessCell let-row>
    @if (row.processUrl) {
      <app-copyable-identifier [value]="row.sourceProcessDefinitionKey" [link]="row.processUrl"></app-copyable-identifier>
    } @else { — }
  </ng-template>
  <ng-template #templateProcessCell let-row>
    @if (row.processUrl) {
      <app-copyable-identifier [value]="row.processKey" [link]="row.processUrl"></app-copyable-identifier>
    } @else { — }
  </ng-template>
  <ng-template #templateEventCell let-row>
    @if (row.eventUrl) {
      <app-copyable-identifier [value]="row.eventKey" [link]="row.eventUrl"></app-copyable-identifier>
    } @else { — }
  </ng-template>

  @if (loading()) {
    <app-loading></app-loading>
  } @else if (tab() === 'rules') {
    <div class="orch-table-panel">
      <app-orchestration-table-heading heading="adminNotifications.rules" [query]="catalogQuery()" (queryChange)="catalogQuery.set($event)">
        <div tableActions class="table-actions">
          <app-primary-button title="adminNotifications.createRule" icon="pi pi-plus" (action)="openCreateRule()"></app-primary-button>
          <app-secondary-button title="adminNotifications.addEmail" (action)="openBulkEmail('add')"></app-secondary-button>
          <app-secondary-button title="adminNotifications.removeEmail" (action)="openBulkEmail('remove')"></app-secondary-button>
          <app-secondary-button title="Refresh" icon="refresh" (action)="reload()"></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <div class="orch-filter-toolbar">
        <div class="orch-filter-toolbar__group">
          <msf-select
            [model]="rulesEventKey()"
            [options]="journalEventOptions()"
            optionLabel="label"
            optionValue="value"
            translateBy="none"
            [placeholder]="'Event' | translate"
            (modelChange)="rulesEventKey.set($event)"
          ></msf-select>
        </div>
        <div class="orch-filter-toolbar__group">
          <msf-select
            [model]="rulesProcessKey()"
            [options]="ruleProcessOptions()"
            optionLabel="label"
            optionValue="value"
            translateBy="none"
            [placeholder]="'Process' | translate"
            (modelChange)="rulesProcessKey.set($event)"
          ></msf-select>
        </div>
        <div class="orch-filter-toolbar__group">
          <msf-select
            [model]="rulesPriority()"
            [options]="priorityFilterOptions"
            optionLabel="label"
            optionValue="value"
            translateBy="none"
            [placeholder]="'adminNotifications.priority' | translate"
            (modelChange)="rulesPriority.set($event)"
          ></msf-select>
        </div>
      </div>
      <app-data-table
        [columns]="ruleColumns()"
        [data]="visibleRules()"
        [config]="ruleTableConfig()"
        (onRowClick)="openRule($event)"
      ></app-data-table>
    </div>
    @if (creatingRule()) {
      <app-admin-notification-rule-page></app-admin-notification-rule-page>
    }
  } @else if (tab() === 'templates') {
    <div class="orch-table-panel">
      <app-orchestration-table-heading heading="adminNotifications.templates" [query]="catalogQuery()" (queryChange)="catalogQuery.set($event)">
        <div tableActions class="table-actions">
          <app-primary-button title="adminNotifications.createTemplate" icon="pi pi-plus" (action)="openCreateTemplate()"></app-primary-button>
          <app-secondary-button title="Refresh" icon="refresh" (action)="reload()"></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <app-data-table [columns]="templateColumns()" [data]="visibleTemplates()" [config]="templateTableConfig()"></app-data-table>
    </div>
  } @else if (tab() === 'messages') {
    <div class="orch-table-panel">
      <app-orchestration-table-heading heading="adminNotifications.messages" [query]="catalogQuery()" (queryChange)="catalogQuery.set($event)">
        <div tableActions class="table-actions">
          <app-secondary-button title="Refresh" icon="refresh" (action)="reload()"></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <div class="orch-filter-toolbar">
        <div class="orch-filter-toolbar__group">
          <msf-select
            [(model)]="messagesEventKey"
            [options]="journalEventOptions()"
            optionLabel="label"
            optionValue="value"
            translateBy="none"
            [placeholder]="'Event' | translate"
            (modelChange)="applyInboxFilters()"
          ></msf-select>
        </div>
        <div class="orch-filter-toolbar__group">
          <app-checkbox
            [(ngModel)]="messagesUnreadOnly"
            label="adminNotifications.unreadOnly"
            (onChange)="applyInboxFilters()"
          ></app-checkbox>
          <app-checkbox
            [(ngModel)]="messagesTestsOnly"
            label="adminNotifications.testsOnly"
            (onChange)="applyInboxFilters()"
          ></app-checkbox>
        </div>
      </div>
      <app-data-table
        [columns]="messageColumns()"
        [data]="visibleInboxItems()"
        [config]="messageTableConfig()"
        (onRowClick)="openInboxRow($event)"
      ></app-data-table>
    </div>
  } @else if (tab() === 'journal') {
    <div class="orch-table-panel">
      <app-orchestration-table-heading heading="adminNotifications.journal" [query]="catalogQuery()" (queryChange)="catalogQuery.set($event)">
        <div tableActions class="table-actions">
          <app-secondary-button title="Refresh" icon="refresh" (action)="reload()"></app-secondary-button>
        </div>
      </app-orchestration-table-heading>
      <div class="orch-filter-toolbar">
        <div class="orch-filter-toolbar__group">
          <msf-select
            [(model)]="journalEventKey"
            [options]="journalEventOptions()"
            optionLabel="label"
            optionValue="value"
            translateBy="none"
            [placeholder]="'Event' | translate"
            (modelChange)="applyJournalFilters()"
          ></msf-select>
        </div>
        <div class="orch-filter-toolbar__group">
          <msf-select
            [(model)]="journalOutcome"
            [options]="outcomeOptions"
            optionLabel="label"
            optionValue="value"
            translateBy="locale"
            [placeholder]="'adminNotifications.outcome' | translate"
            (modelChange)="applyJournalFilters()"
          ></msf-select>
        </div>
        <div class="orch-filter-toolbar__group">
          <app-checkbox
            [(ngModel)]="journalTestsOnly"
            label="adminNotifications.testsOnly"
            (onChange)="applyJournalFilters()"
          ></app-checkbox>
        </div>
      </div>
      <app-data-table
        [columns]="journalColumns()"
        [data]="visibleJournal()"
        [config]="journalTableConfig()"
        (onRowClick)="openJournalRow($event)"
      ></app-data-table>
    </div>
  }
</div>

<p-dialog
  [visible]="bulkEmailMode() !== null"
  (visibleChange)="onBulkEmailVisibleChange($event)"
  [header]="(bulkEmailMode() === 'remove' ? 'adminNotifications.removeEmail' : 'adminNotifications.addEmail') | translate"
  [modal]="true"
  [style]="{ width: '28rem' }"
>
  <div class="dialog-form">
    <msf-input [(model)]="bulkEmail" [label]="'adminNotifications.emailAddress' | translate"></msf-input>
  </div>
  <div class="dialog-actions">
    <app-secondary-button title="Cancel" (action)="onBulkEmailVisibleChange(false)"></app-secondary-button>
    <app-primary-button title="Save" [disable]="bulkEmailBusy()" (action)="applyBulkEmail()"></app-primary-button>
  </div>
</p-dialog>

<p-dialog
  [visible]="templateDialogVisible()"
  (visibleChange)="onTemplateDialogVisibleChange($event)"
  [header]="'adminNotifications.createTemplate' | translate"
  [modal]="true"
  [style]="{ width: '40rem' }"
>
  <div class="dialog-form">
    <msf-input [(model)]="templateName" [label]="'adminNotifications.template' | translate"></msf-input>
    <msf-input [(model)]="templateTitleEn" [label]="'adminNotifications.titleEn' | translate"></msf-input>
    <msf-input [(model)]="templateTitleRu" [label]="'adminNotifications.titleRu' | translate"></msf-input>
    <msf-input [(model)]="templateTitleUz" [label]="'adminNotifications.titleUz' | translate"></msf-input>
    <app-textarea [(ngModel)]="templateBodyEn" label="adminNotifications.bodyEn" [rows]="4"></app-textarea>
    <app-textarea [(ngModel)]="templateBodyRu" label="adminNotifications.bodyRu" [rows]="4"></app-textarea>
    <app-textarea [(ngModel)]="templateBodyUz" label="adminNotifications.bodyUz" [rows]="4"></app-textarea>
    <div class="form-field">
      <div class="field-label">{{ 'adminNotifications.sourceProcess' | translate }}</div>
      <msf-select
        [model]="templateProcessKey()"
        (modelChange)="templateProcessKey.set($event)"
        [options]="templateProcesses()"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'adminNotifications.sourceProcess' | translate"
        translateBy="locale"
        [showClear]="true"
      ></msf-select>
    </div>
    <section class="template-fields__variables-block">
      <h3>{{ 'adminNotifications.commonParameters' | translate }}</h3>
      <table class="template-fields__variables">
        <tbody>
          @for (variable of commonTemplateParameters; track variable.token) {
            <tr>
              <td><code>{{ variable.token }}</code></td>
              <td>{{ variable.descriptionKey | translate }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
    @if (templateProcessKey() && processTemplateParameters().length) {
      <section class="template-fields__variables-block">
        <h3>{{ 'adminNotifications.processParameters' | translate }}</h3>
        <table class="template-fields__variables">
          <tbody>
            @for (variable of processTemplateParameters(); track variable.token) {
              <tr>
                <td><code>{{ variable.token }}</code></td>
                <td>{{ variable.descriptionKey | translate }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    }
    <msf-input [(model)]="templateDeepLink" [label]="'adminNotifications.deepLink' | translate"></msf-input>
    <app-checkbox [(ngModel)]="templateAttachments" label="adminNotifications.attachments"></app-checkbox>
    <app-checkbox [(ngModel)]="templatePreview" label="adminNotifications.preview"></app-checkbox>
    <app-checkbox [(ngModel)]="templateRetired" label="adminNotifications.retired"></app-checkbox>
  </div>
  <div class="dialog-actions">
    <app-secondary-button title="Cancel" (action)="onTemplateDialogVisibleChange(false)"></app-secondary-button>
    <app-primary-button title="Save" (action)="saveTemplate()"></app-primary-button>
  </div>
</p-dialog>

<p-dialog
  [visible]="!!journalDetail()"
  (visibleChange)="onJournalDetailVisibleChange($event)"
  [header]="'adminNotifications.journal' | translate"
  [modal]="true"
  [style]="{ width: '36rem' }"
>
  @if (journalDetail(); as row) {
    <dl class="settings">
      <dt>{{ 'adminNotifications.event' | translate }}</dt>
      <dd>{{ row.eventKey }}</dd>
      <dt>{{ 'adminNotifications.recipient' | translate }}</dt>
      <dd>{{ row.recipientUserId || '—' }}</dd>
      <dt>{{ 'adminNotifications.recipientEmail' | translate }}</dt>
      <dd>{{ row.recipientEmail || '—' }}</dd>
      <dt>{{ 'adminNotifications.channel' | translate }}</dt>
      <dd>{{ row.channelKey }}</dd>
      <dt>{{ 'adminNotifications.outcome' | translate }}</dt>
      <dd>{{ row.outcome }}</dd>
      <dt>{{ 'adminNotifications.reason' | translate }}</dt>
      <dd>{{ row.reason || '—' }}</dd>
      <dt>{{ 'adminNotifications.deepLink' | translate }}</dt>
      <dd>{{ row.deepLink || '—' }}</dd>
    </dl>
    <p><strong>{{ row.renderedTitle }}</strong></p>
    <div class="notification-rendered-body" [innerHTML]="row.renderedBody"></div>
  }
</p-dialog>

<p-dialog
  [visible]="!!inboxDetail()"
  (visibleChange)="onInboxDetailVisibleChange($event)"
  [header]="'adminNotifications.messages' | translate"
  [modal]="true"
  [style]="{ width: '36rem' }"
>
  @if (inboxDetail(); as row) {
    <dl class="settings">
      <dt>{{ 'adminNotifications.event' | translate }}</dt>
      <dd>{{ row.eventKey }}</dd>
      <dt>{{ 'adminNotifications.recipient' | translate }}</dt>
      <dd>{{ row.recipientUserId || '—' }}</dd>
      <dt>{{ 'adminNotifications.priority' | translate }}</dt>
      <dd>{{ row.priority }}</dd>
      <dt>{{ 'adminNotifications.readAt' | translate }}</dt>
      <dd>{{ row.readAt || ('adminNotifications.unread' | translate) }}</dd>
      <dt>{{ 'adminNotifications.deepLink' | translate }}</dt>
      <dd>{{ row.deepLink || '—' }}</dd>
    </dl>
    <p><strong>{{ row.title }}</strong></p>
    <p>{{ row.body }}</p>
    <div class="dialog-actions">
      <app-secondary-button title="adminNotifications.openRule" (action)="openInboxRule()"></app-secondary-button>
    </div>
  }
</p-dialog>
